import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from "../header/header.component";

@Component({
  selector: 'app-home',
  imports: [FooterComponent, HeaderComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
// export class HomeComponent {} codigo borrador de abajo


export class HomeComponent implements OnInit{
  constructor(private titleService: Title){}
  ngOnInit(): void {
    this.titleService.setTitle("Manual de pagos") // Título de la página
  }
}